import React from 'react';
import PropTypes from 'prop-types';

import PanelWithUpsell from './PanelWithUpsell.jsx';

import PostsTableComponent from './PostsTableComponent.jsx';

import {
    listeningDefinitions
} from './enums/listeningDefinitions.jsx';

PostsTable.propTypes = {
    instanceId: PropTypes.string.isRequired,
    className: PropTypes.string,
    title: PropTypes.string,
    pdfExportConfig: PropTypes.object,
    appSpecificExportConfig: PropTypes.object
};


export default function PostsTable({instanceId, className, title, pdfExportConfig, appSpecificExportConfig}) {

    const {
        title: definitionTitle = `Top Posts`,
        description,
        footer: footerContextView
    } = listeningDefinitions[instanceId] || {};

    title = title || definitionTitle;

    return (
        <PanelWithUpsell
            instanceId={instanceId}
            title={title}
            description={description}
            exportSubtitle={appSpecificExportConfig?.timePeriodStr}
            showViewMore={true}
            className={className}
            footerContextView={footerContextView}
        >
            <PostsTableComponent
                instanceId={instanceId}
                showSinglePostModals={true}
                pdfExportConfig={pdfExportConfig}
                appSpecificExportConfig={appSpecificExportConfig}
            />
        </PanelWithUpsell>
    );
}
